'use strict';

var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _extend = require('lodash/object/extend');

var _extend2 = _interopRequireDefault(_extend);

var _messages = require('common/messages');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

module.exports = {

    /**
    * isNew is either explicitly set by you, or set via the existence of the data property, which is always set when when we have retrieved from the backend.
    */

    initialize: function initialize() {

        if (!this.notifier) {
            console.error('notifier does not exist for model apiEndpoints: %s, data: ', this.apiEndpoints, this.data);
        }

        if (!this.isNew) {
            this.isNew = function () {
                return !this.data;
            };
        }
    },

    /**
    */

    toJSON: function toJSON() {
        return this.toData();
    },

    /**
    */

    save: function save(onSave) {
        var method = this.isNew() ? this.insert : this.update;
        return method.call(this, onSave);
    },

    /**
    */

    insert: function insert(onSave) {
        return this._run(_messages.INSERT, onSave);
    },

    /**
    */

    update: function update(onSave) {
        return this._run(_messages.UPDATE, onSave);
    },

    /**
    */

    load: function load(onLoad) {
        return this._run(_messages.LOAD, onLoad);
    },

    /**
    */

    remove: function remove(onLoad) {
        return this._run(_messages.REMOVE, onLoad);
    },

    /**
    */

    fetch: function fetch(operationName, options, onRun) {

        if (typeof options === 'function') {
            onRun = options;
            options = {};
        }
        // KEEP THIS HERE. If notifier does not exist, throw a very descriptive & debuggable message. (CC)
        if (!this.notifier) {
            throw new Error('notifier does not exist for model with apiEndpointAlias: ' + this.apiEndpointAlias);
        }

        var promise = Promise.resolve(this.notifier.notify(_messages.RequestMessage.create(operationName, this.apiEndpointAlias, _extends({ target: this }, options)))).then(function (_ref) {
            var _ref2 = _slicedToArray(_ref, 1);

            var data = _ref2[0];

            return data || {};
        });

        if (onRun) {
            console.warn('DEPRECATED: call then() on returned promise instead');
            promise['catch'](onRun).then(onRun.bind(this, void 0));
        }

        return promise;
    },

    /**
    */

    _run: function _run(operationName, onRun) {

        if (!onRun) {
            onRun = function onRun() {};
        }

        var beforeOnRun = function (error, data) {

            var props = {
                loading: false
            };

            if (error) {
                props.error = error;

                // check if there's any data at all
            } else if (!!Object.keys(data).length) {
                    props.data = (0, _extend2['default'])({}, data);
                }

            this.setProperties(props);
            onRun.apply(this, arguments);
        }.bind(this);

        this.setProperties({
            'error': void 0,
            'loading': true
        });

        var ret = this.fetch(operationName);
        ret.then(beforeOnRun.bind(this, void 0), beforeOnRun);
        return ret;
    }
};


/*****************
 ** WEBPACK FOOTER
 ** ./src/common/models/mixins/model.js
 ** module id = 386
 ** module chunks = 0
 **/